import useAccount from '@rhg/hooks/use-account';
import useAuth from '@rhg/libs/auth0/use-auth';
import { ReactNode } from 'react';

interface Props {
    children: ReactNode;
    requireAccount?: boolean;
    // TODO implement this when we have more registration steps
    // requireRegisteredAccount?: boolean;
    fallback?: ReactNode;
}

const AuthenticatedComponent = ({
    children,
    fallback,
    requireAccount = false,
}: // TODO implement this when we have more registration steps
// requireRegisteredAccount = false,
Props) => {
    const { isAuthenticated, isLoading } = useAuth();
    const { account } = useAccount();
    if (!isLoading && isAuthenticated && (requireAccount ? !!account : true)) {
        return <>{children}</>;
    } else {
        return <>{fallback || null}</>;
    }
};

export default AuthenticatedComponent;
